import React, { useEffect, useState } from "react";
import { Database, Cloud, FileSpreadsheet, Plug, CheckCircle2, UploadCloud, ArrowRight } from "lucide-react";
import { api } from "../../services/api";

const ICON = { API: Cloud, Database: Database, "Scheduled Extract": ArrowRight, "CSV/SFTP": FileSpreadsheet };

export default function VansConnectors() {
  const [connectors, setConnectors] = useState([]);
  const [uploading, setUploading] = useState(null);

  useEffect(() => { api.vansConnectors().then((d) => setConnectors(d.connectors)); }, []);

  const simulate = (id) => { setUploading(id); setTimeout(() => setUploading(null), 1400); };

  return (
    <div className="conn-page">
      <div className="conn-intro">
        <div className="conn-intro-icon"><Plug size={20} /></div>
        <div>
          <div className="conn-intro-title">Source Connectors & Ingestion</div>
          <p>DotIQ ingests six Vans demand & inventory signals. Each record keeps source provenance. Re-upload a CSV extract to simulate an incremental sync — the correlation engine re-runs on ingest.</p>
        </div>
      </div>

      <div className="conn-grid">
        {connectors.map((c) => {
          const Ic = ICON[c.type] || Cloud;
          return (
            <div key={c.id} className="conn-card">
              <div className="conn-card-top">
                <div className="conn-card-icon"><Ic size={18} /></div>
                <span className="conn-status"><CheckCircle2 size={13} /> {c.status}</span>
              </div>
              <div className="conn-name">{c.name}</div>
              <div className="conn-system">{c.system} · {c.type}</div>
              <div className="conn-entities">{c.entities.map((e) => <span key={e} className="ent-chip">{e}</span>)}</div>
              <div className="conn-foot">
                <span className="conn-records">{c.records.toLocaleString("en-US")} records</span>
                <button className="btn-ghost sm" onClick={() => simulate(c.id)} disabled={uploading === c.id}>
                  <UploadCloud size={14} className={uploading === c.id ? "spin" : ""} />
                  {uploading === c.id ? "Ingesting…" : "Sync extract"}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="pipeline-strip">
        <div className="ps-title">End-to-end product loop</div>
        <div className="ps-steps">
          {["CONNECT", "DETECT", "CORRELATE", "RANK", "EXPLAIN", "DECIDE"].map((s, i) => (
            <React.Fragment key={s}>
              <span className="ps-step">{s}</span>
              {i < 5 && <span className="ps-arrow">→</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
